import { Button, Card, Form, InputNumber, message, Tag } from "antd";
import React, { useEffect } from "react";
import Filterbox from "../FilterBox/Filterbox";
import SpPagination from "../../components/SpPagination/SpPagination";
import { useDispatch, useSelector } from "react-redux";
import { listUserCommissions, updateUserCommission } from "../../redux/actions/user";
import {
  selectUpdateUserCommissionLoading,
  selectUserCommissions,
  selectUserCommissionsLoading,
  selectUserCommissionsPagination,
} from "../../redux/selectors/userSelectors";
import ProgressLoader from "../../components/Loader/ProgressLoader";
import DataTable from "../DataTable/DataTable";

const CommissionTable = ({data}) => {
  const userCommissionList = useSelector(selectUserCommissions);
  const isLoading = useSelector(selectUserCommissionsLoading);
  const isUpdating = useSelector(selectUpdateUserCommissionLoading);

  const commissionPagination = useSelector(selectUserCommissionsPagination);

  const { totalRecords = 20, pageSize = 10, currentPage = 1 } = commissionPagination || {};


  const dispatch = useDispatch();
  const [form] = Form.useForm();

  useEffect(() => {
    if (!data?.id) return;

    dispatch(listUserCommissions({ user_id: data?.id })).catch(err => {
      message.error(err);
    });
  }, [data?.id, dispatch]);

  const handleSave = (record) => {
    const values = form.getFieldsValue();
    const rowValues = values?.commissions?.[record.id] || {};

    dispatch(updateUserCommission({
      id: data?.id,
      provider_id: record.provider_id,
      service_id: record.service_id,
      channel_id: record.channel_id,
      ...rowValues,
    })).then((res) => {
      message.success(res?.message || "Commission updated.");
      dispatch(listUserCommissions({ user_id: data?.id, nextPage: currentPage }));
    }).catch((err) => message.error(err));
  };

  const columns = [
    {
      title: "Service",
      dataIndex: "service",
      key: "service",
      width: 260,
      render: (value) => value?.name || "N/A",
    },
    {
      title: "Provider",
      dataIndex: "provider",
      key: "provider",
      width: 180,
      render: (value) => value?.name || "N/A",
    },
    {
      title: "Channel",
      dataIndex: "channel",
      key: "channel",
      width: 140,
      render: (value) => value?.type || value?.description || "Default",
    },
    {
      title: "Customer Rate",
      key: "cust_comm_value",
      width: 180,
      render: (_, record) => (
        <Form.Item name={["commissions", record.id, "cust_comm_value"]} initialValue={Number(record?.cust_comm_value || 0)} noStyle>
          <InputNumber min={0} precision={4} />
        </Form.Item>
      ),
    },
    {
      title: "Customer Cap",
      key: "cust_cap",
      width: 180,
      render: (_, record) => (
        <Form.Item name={["commissions", record.id, "cust_cap"]} initialValue={Number(record?.cust_cap || 0)} noStyle>
          <InputNumber min={0} precision={2} />
        </Form.Item>
      ),
    },
    {
      title: "Referral Rate",
      key: "ref_comm_value",
      width: 180,
      render: (_, record) => (
        <Form.Item name={["commissions", record.id, "ref_comm_value"]} initialValue={Number(record?.ref_comm_value || 0)} noStyle>
          <InputNumber min={0} precision={4} />
        </Form.Item>
      ),
    },
    {
      title: "Referral Cap",
      key: "ref_cap",
      width: 180,
      render: (_, record) => (
        <Form.Item name={["commissions", record.id, "ref_cap"]} initialValue={Number(record?.ref_cap || 0)} noStyle>
          <InputNumber min={0} precision={2} />
        </Form.Item>
      ),
    },
    {
      title: "Type",
      key: "rate_type",
      width: 140,
      render: (_, record) => (
        <Tag>{record?.is_cust_comm_value_flat ? "FLAT" : "PERCENT"}</Tag>
      ),
    },
    {
      title: "Action",
      key: "action",
      width: 120,
      fixed: "right",
      render: (_, record) => (
        <Button type="primary" loading={isUpdating} onClick={() => handleSave(record)}>
          Save
        </Button>
      ),
    },
  ];

  return (
    <ProgressLoader isLoading={isLoading}>
      <Card className="api-overview__table-card">
        <Filterbox 
          showButtons={false} 
          displayFilter={"none"} 
          searchAction={listUserCommissions}
          searchIsLoading={isLoading} 
          searchActionData={{user_id: data?.id}}
        />
        <Form form={form}>
          <DataTable
            dataSource={userCommissionList}
            columns={columns}
            scrollX={1420}
          />
        </Form>
      </Card>
      <SpPagination
        defaultCurrent={currentPage}
        total={totalRecords}
        pageSize={pageSize}
        onChange={(value) => {
          dispatch(listUserCommissions({ nextPage: value, user_id: data?.id })).catch(err => message.error(err));
        }}
      />
    </ProgressLoader>
  );
};

export default CommissionTable;
